import { FirebaseAdminProxyAPI } from '../../api/proxy/FirebaseAdminProxyAPI';

export const AdminCreateFirebaseAdminProxyAPI = new FirebaseAdminProxyAPI(
  'adminCreateFirebaseAdminProxyApiReducer'
);
